import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";
import type { RouteObject } from "react-router-dom";

import { ReferrerDetailPage } from "./referrer-detail-page";
import { ReferrersPage } from "./referrers-page";

const referrerDetailBreadcrumb = breadcrumbSlot();

export const referrersRoutes: RouteObject[] = [
  {
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        handle: { breadcrumb: "Referrers" },
        element: <ReferrersPage />,
      },
      {
        path: ":referrerId",
        handle: { breadcrumb: "Referrer" },
        children: [
          {
            index: true,
            handle: { breadcrumb: referrerDetailBreadcrumb },
            element: (
              <ReferrerDetailPage breadcrumb={referrerDetailBreadcrumb} />
            ),
          },
        ],
      },
    ],
  },
];
